import t from 'common/i18n';
import validateImageForUpload from './validateImageForUpload';

const validateMinDimensions = (width, height, minWidth, minHeight) => {
  let isValid = true;

  if (minWidth && width < minWidth) {
    isValid = false;
  }

  if (isValid && minHeight && height < minHeight) {
    isValid = false;
  }

  return isValid;
};

const getMinInvalidMessage = (width, height, minWidth, minHeight) =>
  t('uploader.errors.min_dimensions_validation', {
    width,
    height,
    minWidth: minWidth || t('uploader.errors.unavailable'),
    minHeight: minHeight || t('uploader.errors.unavailable'),
  });

export default (context, data, options) =>
  validateImageForUpload(
    data,
    context,
    (img, dfd) => {
      const width = img.naturalWidth;
      const height = img.naturalHeight;
      const minWidth = data.imageMinWidth;
      const minHeight = data.imageMinHeight;

      const isValid = validateMinDimensions(width, height, minWidth, minHeight);

      if (isValid) {
        dfd.resolveWith(context, [data]);
      } else {
        const error = getMinInvalidMessage(width, height, data.imageMinWidth, data.imageMinHeight);

        data.files.error = true;
        data.files[0] = { error };
        dfd.rejectWith(context, [data]);
      }
    },
    options
  );
